<template>
  <div class="w-full absolute bottom-0 px-6 pt-2 h-[100px] bg-white z-[3]">
    <div class="flex justify-between items-center">
      <!-- Quantity Controls -->
      <div class="flex gap-3 text-gray-800" v-if="isAddedToCart">
        <div
          :class="{
            'opacity-50 cursor-not-allowed': !isRestaurantOpen,
            'bg-[#F4F4F5] ripple': isRestaurantOpen
          }"
          class="rounded-2xl w-11 h-11 text-2xl items-center justify-center flex"
          @click="isRestaurantOpen ? $emit('decrease') : null"
        >
          <div>-</div>
        </div>
        <div
          class="rounded-2xl w-11 h-11 text-2xl items-center justify-center flex"
        >
          <div>{{ quantity }}</div>
        </div>
        <div
          :class="{
            'opacity-50 cursor-not-allowed': !isRestaurantOpen,
            'bg-[#F4F4F5] ripple': isRestaurantOpen
          }"
          class="rounded-2xl w-11 h-11 text-2xl items-center justify-center flex"
          @click="isRestaurantOpen ? $emit('increase') : null"
        >
          <div>+</div>
        </div>
      </div>

      <!-- Add/Remove Button -->
      <div class="text-center relative w-full">
        <button
          :class="{
            'opacity-50 cursor-not-allowed ': !canOrder
          }"
          class="py-6! buttonComponent w-full"
          @click="$emit('add-to-cart')"
          v-if="!isAddedToCart"
          :disabled="!canOrder"
        >
          <div>Ajouter Au Panier</div>
          <!-- <div>{{ totalAmount }} FCFA</div> -->
        </button>
        <div class="text-right"
            v-else
        >
          <div class="text-xl ">Total: <span class="font-bold title-color"> {{ totalAmount }} FCFA </span></div>
          <button class="underline"
            @click="$emit('remove-from-cart') "
          >Retirer du panier</button>
          <!-- <button
            :class="{
              'opacity-50 cursor-not-allowed': !isRestaurantOpen
            }"
            class="py-4 buttonComponent bg-[#F4F4F5] border-primary-500 border-2 text-primary-500"
            @click="isRestaurantOpen ? $emit('remove-from-cart') : null"
            :disabled="!isRestaurantOpen"
          >
            <div>Retirer</div>
            <div>{{ totalAmount }} FCFA</div>
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  dishData: {
    type: Object,
    required: true
  },
  canOrder: {
    type: Boolean,
    default: true
  },
  isRestaurantOpen: {
    type: Boolean,
    default: true
  },
  itemQuantity: {
    type: Number,
    default: 1
  },
  totalPrice: {
    type: Number,
    default: 0
  },
  isAddedToCart: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([
  'add-to-cart',
  'remove-from-cart',
  'increase',
  'decrease'
]);

// Use computed instead of ref to react to prop changes
const quantity = computed(() => props.itemQuantity);

// Computed
const totalAmount = computed(() => {
  return props.totalPrice || 0;
});
</script>

<style scoped>
.buttonComponent {
  background-color: #f59e0b;
  color: white;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  font-weight: bold;
  min-width: 180px;
}
</style>
